import { render, staticRenderFns } from "./InfoBoxOne.vue?vue&type=template&id=4c0555f2&scoped=true&"
import script from "./InfoBoxOne.vue?vue&type=script&lang=js&"
export * from "./InfoBoxOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0555f2",
  null
  
)

export default component.exports